import { en } from './locales/en';
import { ru } from './locales/ru';
import { uk } from './locales/uk';
import { de } from './locales/de';
import { it } from './locales/it';
import { fr } from './locales/fr';
import { zh } from './locales/zh';

export const interfaceResources = {
  en: { translation: en },
  ru: { translation: ru },
  uk: { translation: uk },
  de: { translation: de },
  it: { translation: it },
  fr: { translation: fr },
  zh: { translation: zh },
};
